import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';
import TooltipComponent from '@prisjakt/ui-tooltip-new';

const iconAndTextPadding = '0 8px';

export const StockStatus = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 1.5rem;
`;

export const IconAndText = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  padding: ${iconAndTextPadding};
`;

export const Text = styled.span`
  display: block;
  text-align: left;
  color: ${props => (!props.toneDown ? colors.darkGray2 : colors.darkGray4)};
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const Tooltip = styled(TooltipComponent)`
  *:first-child {
    &::first-letter {
      text-transform: capitalize;
    }
  }
`;

const getIconStyling = (status, toneDown) => {
  switch (status) {
    case 'in_stock_preorder':
    case 'incoming':
      return `background-color: ${colors.white}; box-shadow: inset 0 0 0 2px ${
        toneDown ? colors.lightGray2 : colors.green1
      }`;
    case 'in_stock':
      return toneDown
        ? `background-color: ${colors.lightGray1}`
        : `background-color: ${colors.green1}`;
    case 'not_in_stock':
      return toneDown
        ? `background-color: ${colors.lightGray1}`
        : `background-color: ${colors.red2}`;
    default:
      return toneDown
        ? `background-color: ${colors.lightGray1};`
        : `background-color: ${colors.darkGray1}`;
  }
};

export const Icon = styled.span`
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin: 5px;
  ${props => getIconStyling(props.status, props.toneDown)};
`;
